import React, {
  useState,
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import { css } from "@emotion/core";
import { mainColor } from "../../constants/colors";
import { Desktop, Tablet } from "../../constants/responsive";
import { FormattedHTMLMessage } from "gatsby-plugin-intl";

const Pagination = ({ value, onChange, max }, ref = null) => {
  const mainRef = useRef();
  useImperativeHandle(ref, () => mainRef.current);

  const [goToPage, setGoToPage] = useState(null);

  return (
    <div
      ref={mainRef}
      className="js-pagination"
      css={css`
        display: flex;
        justify-content: center;
        ${Tablet} {
          justify-content: flex-end;
        }
        flex-wrap: wrap;
        align-items: center;
        font-size: 20px;
        color: ${mainColor};
      `}
    >
      <div
        css={css`
          height: 40px;
          border-radius: 6px;
          border: 1px solid ${value === 1 ? "grey" : mainColor};
          color: ${value === 1 ? "grey" : mainColor};
          pointer-events: ${value === 1 ? "none" : "auto"};
          font-weight: bold;
          padding: 0px 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          background: white;
          transition: all 0.2s ease;
          user-select: none;
          margin-right: 20px;
          &:hover {
            background: ${mainColor};
            color: white;
          }
        `}
        onClick={() => {
          onChange(value - 1);
        }}
      >
        {`←`}
      </div>
      <div
        css={css`
          display: block;
          ${Tablet} {
            display: block;
          }
          font-weight: bold;
        `}
      >
        {value} of {max}
      </div>
      <div
        css={css`
          height: 40px;
          border-radius: 6px;
          border: 1px solid ${value === max ? "grey" : mainColor};
          color: ${value === max ? "grey" : mainColor};
          pointer-events: ${value === max ? "none" : "auto"};
          font-weight: bold;
          padding: 0px 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          background: white;
          transition: all 0.2s ease;
          user-select: none;
          margin-left: 20px;
          &:hover {
            background: ${mainColor};
            color: white;
          }
        `}
        onClick={() => {
          onChange(value + 1);
        }}
      >
        {`→`}
      </div>
      <hr
        css={css`
          height: 20px;
          ${Tablet} {
            flex: 0 0 20px;
          }
        `}
      />
      <div
        css={css`
          display: flex;
          ${Tablet} {
            display: flex;
            align-items: center;
          }
        `}
      >
        <div>
          <FormattedHTMLMessage id="footer.paging.goto" />
        </div>
        <input
          type="number"
          min={1}
          max={max}
          css={css`
            width: 40px;
            height: 40px;
            border-radius: 6px;
            border: 1px solid ${mainColor};
            margin: 0px 10px;
            text-align: center;
            color: ${mainColor};
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
          `}
          onChange={(e) => {
            setGoToPage(e.target.value);
          }}
        />
        <div>
          <FormattedHTMLMessage id="footer.paging.page" />
        </div>
        <div
          css={css`
            width: 60px;
            height: 40px;
            border-radius: 6px;
            border: 1px solid ${mainColor};
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background: white;
            transition: all 0.2s ease;
            user-select: none;
            margin-left: 10px;
            &:hover {
              background: ${mainColor};
              color: white;
            }
          `}
          onClick={() => {
            let newPage = Number(goToPage);
            if (newPage < 1) {
              newPage = 1;
            }
            if (newPage > max) {
              newPage = max;
            }
            onChange(newPage);
          }}
        >
          <FormattedHTMLMessage id="footer.paging.go" />
        </div>
      </div>
    </div>
  );
};

export default forwardRef(Pagination);
